// Aggregated networks only. Source sample rows stay on the server.
export const geneNetworks = bundle => bundle?.schemaVersion === 2 ? bundle.networks || [] : bundle?.gene ? [bundle] : [];
export const uploadForGene = (bundle, gene) => geneNetworks(bundle).find(row => row.gene === gene) || null;
export const withUploadBuild = (bundle, build) => bundle?.schemaVersion === 2
    ? { ...bundle, genomeBuild: build, networks: bundle.networks.map(row => ({ ...row, genomeBuild: build })) }
    : { ...bundle, genomeBuild: build };
export function mergeQueryScope(version, unit, comparing, unitB, filters) {
    const { gene, ...conditions } = filters;
    return JSON.stringify([version, unit, comparing, unitB, conditions]);
}
export function uploadOnlyNetwork(context, gene) {
    return { ...context, gene, nodes: [], edges: [], graphContext: { nodes: [], edges: [], targetIds: [] },
        dataMissing: true, uploadOnly: true, message: '暂无系统网络，仅显示用户上传数据；未确认该基因与当前疾病单元的关联。',
        sourceSummary: { variants: null, pairs: null, largestComponent: null },
        stats: { pairRows: null, largestComponentFraction: null }, queryOptions: null };
}
